import { IPublicPendingTaskPollingResponse } from '~/types/server.types';
import { CXRootStore } from '~/components/ClientExperience/stores/cx-root.store';

export class PublicPendingTaskService {
    rootStore: CXRootStore;

    constructor(rootStore: CXRootStore) {
        this.rootStore = rootStore;
    }

    async fetchPublicPendingTaskData(s3FileUrl: string) {
        const { s3ApiAdapter } = this.rootStore;
        return s3ApiAdapter.apiRequest<IPublicPendingTaskPollingResponse>({
            baseURL: '',
            url: s3FileUrl,
            headers: { crossDomain: true }
        });
    }
}
